import { render, staticRenderFns } from "./BaseBatchView.vue?vue&type=template&id=2f099fef&scoped=true&"
import script from "./BaseBatchView.vue?vue&type=script&lang=js&"
export * from "./BaseBatchView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f099fef",
  null
  
)

export default component.exports